import request from '@/request';
/**
 * @description 检查域名是否允许访问
 * @param params.domain 域名
 * @param params.channelCode 渠道编码
 * @returns 返回域名是否允许访问的结果
 */
export const getCheckDomain = (params: { pDomain: string | null; channelCode: string | null }) => {
  const tempParams = {
    api: 'gop.alipic.icirena.own.cinema.checkdomain',
    data: {
      ...params,
    },
  };
  return request<{ allow: boolean }>(tempParams);
};
